// MACHINERY V2 (Stroje) — the phone status-counter chip row, Fleet V2 (M2.16b).
//
// Rendered truth: mobile/screenshots/09-v2-phone.png, viewed before this file
// was written. The board draws it directly under the page head:
// `Filtre | Bežia 4 | Stoja 1 | Alarm 1 | Vypnut…`, scrolling off the right
// edge.
//
// ============================================================
//  IT IS ADDITIVE. IT DOES NOT REPLACE ROW 1 OF PATTERN B.
// ============================================================
// Board 09 draws pattern A — a `Filtre` chip and status counters, and NO search
// field — because it was drawn while A/B/C were still being compared. The
// MANAGER RULING for this sub-phase is ONE FilterBarB anatomy on all four
// views: row 1 (search + Filtre(n)) is identical everywhere, and board 09's
// counters are an EXTRA row on V2 rather than a swap. Two reasons it matters
// beyond consistency: dropping search on one view would make "where did the
// search box go" a per-view question, and the `Filtre` chip the board draws is
// already row 1's Filtre button — rendering both would be two controls opening
// the same sheet. >>> DO NOT "fix" this back to the PNG by deleting the search
// field. <<<
//
// ONE FILTER STATE. The chips toggle `machineryV2UiSlice.fleetStatusFilters` —
// the SAME array the desktop LiveFleetStrip toggles, the rail's Stav section
// sets and the mobile sheet's STAV section stages. There is no second copy of a
// status filter anywhere in this module.
//
// VOCABULARY IS FLEET_STATE_FILTERS, so this row can never offer a state the
// rail or the sheet does not (its own header: "or a state becomes filterable in
// one place and invisible in the other"). That is NINE chips where the board
// draws four; the board's mock fleet simply has fewer states. Nine chips do not
// fit 390px, which is exactly what the ChipScroller and its right-edge fade are
// for.
//
// PHONE ONLY, and V2 ONLY — FleetContent owns that gate; see its render site.
//
// No Tailwind, no shadcn, no MUI, no @emotion, no sx, no dt tokens.
import React from "react";

import useTranslation from "../../../../shared/hooks/useTranslation";
import ChipScroller from "../mobile/ChipScroller";
import TouchChip from "../mobile/TouchChip";
import { MachineryV2CardState } from "./cardStates";
import { FLEET_STATE_FILTERS } from "./fleetStatusFilters";

export interface FleetStatusChipsProps {
  /** countStates() over the base set — the same object LiveFleetStrip takes. */
  counts: Record<string, number>;
  selected: MachineryV2CardState[];
  onToggle: (state: MachineryV2CardState) => void;
}

const FleetStatusChips: React.FC<FleetStatusChipsProps> = ({
  counts,
  selected,
  onToggle,
}) => {
  const { translate } = useTranslation("myMachinery");

  return (
    // The wrapper carries the separation from the first group header. The
    // scroll area is a BLOCK container, so unlike the flex column inside a body
    // there is no `gap` to inherit — LiveFleetStrip solves the same problem with
    // its own `marginBottom: 14`.
    <div style={{ marginBottom: 8, minWidth: 0 }}>
      {/* paddingInline 0: this row sits INSIDE FleetContent's scroll area,
          which already carries the 14px page margin below 1280 (step 1a). The
          fade therefore resolves to the page background, not to a card. */}
      <ChipScroller fadeTo="var(--bg)" gap={4} paddingInline={0} paddingBlock={0}>
        {FLEET_STATE_FILTERS.map((s) => (
          <TouchChip
            key={s.state}
            active={selected.indexOf(s.state) >= 0}
            ariaPressed={selected.indexOf(s.state) >= 0}
            onClick={() => onToggle(s.state)}
            count={counts[s.state] || 0}
          >
            {translate(s.labelKey)}
          </TouchChip>
        ))}
      </ChipScroller>
    </div>
  );
};

export default FleetStatusChips;
